import React from "react"

import {ArticleList} from "./list/ArticleList"
import {IntroSection, TitleSection} from "~/components/"

import {Trans, useTranslation} from "react-i18next"

const introImage = require("~/images/ProductView Intro.svg")

const ArticlesView = () => {
  const {t} = useTranslation()
  return (
    <React.Fragment>
      <TitleSection>
        <h3>{t("articles.title")}</h3>
      </TitleSection>
      <IntroSection image={introImage}>
        <p>
          <Trans i18nKey="articles.intro">
            <strong>Ein Artikelstamm</strong> enthält grundsätzliche
            Informationen über einen Lagerartikeltyp. Die{" "}
            <strong>Lagerartikel</strong>, welche schliesslich im Warenlager
            verwaltet werden, sind jeweils mit einem solchen Artikelstamm
            verknüpft.
          </Trans>
        </p>
      </IntroSection>

      <ArticleList />
    </React.Fragment>
  )
}
export default ArticlesView



// WEBPACK FOOTER //
// ./src/views/ArticlesView.js